import { calcRem } from "@the-game/components/utils";
import styled from "@emotion/styled";
export const StyledDatePickerContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr 2fr",
  flexDirection: "column",
  gridGap: calcRem(theme.spacing.xs)
}));
